import React, { useState, useRef } from 'react';
import './DocumentCard.css';
import { FaFilePdf, FaImage, FaTrash, FaExpand, FaChevronDown, FaChevronUp, FaFolderOpen, FaUpload } from 'react-icons/fa';
import DocumentViewer from 'components/DocumentViewer';
import { DocumentIcons } from './Assets/DocumentIcons';
const DocumentCard = ({ 
  title, 
  subtitle, 
  description, 
  onUploadComplete,
  acceptedFiles = ['.jpg', '.jpeg', '.png', '.pdf'],
  maxSize = 20 * 1024 * 1024, // 20MB
  open,
  setUploadDropdown,
  files = [], // Added default empty array
  onDrop,
  getInputProps,
  remove,
  disabled,
  isRequired=false
}) => {
 
  
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDocument, setShowDocument] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);

  // Don't modify files directly - files should be managed by parent component
  // Remove the removeFile function since you're getting 'remove' as a prop

  const previewFile = (file) => {
    setCurrentFile(file);
    setShowDocument(true);
  };

  const handleDocumentUpload = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const isImage = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    return ['jpg', 'jpeg', 'png'].includes(ext);
  };

  const isPdf = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    return ext === 'pdf';
  };

  // Ensure files is always an array
  const fileList = Array.isArray(files) ? files : [];

  return (
    <div className={`document-card ${fileList.length > 0 ? 'has-files' : ''}`}>
      <div className="document-card-content">
        <div className="document-info">
          <div className="document-icon">
            <DocumentIcons title={title} />
          </div>
          <div>
            <div style={{display: "flex", gap: 20}}><span><h3 className="document-title">{title}</h3></span> {isRequired && <span style={{color: "red", background: "#ffb3b381", fontSize: 10,marginBottom:10 ,padding: "0 10px", borderRadius: 5, display: "flex", alignItems: "center", fontWeight: "bold"}}>REQUIRED</span>}</div>
            <p className="document-subtitle">{subtitle}</p>
            {description && <p className="document-description">{description}</p>}
          </div>
        </div>

        <div className="upload-section">
          <div className="upload-action">
            <input {...getInputProps()} />
            <span 
              className="upload-button"
              disabled={disabled}
              onClick={() => {
                open();
                if (setUploadDropdown) {
                  setUploadDropdown(false);
                }
              }}
            >
              <FaUpload />
              <span>{fileList.length > 0 ? 'Uploaded' : 'Upload Now'}</span>
            </span>
          </div>
          <div className="upload-info">
            <small>Max size: 20MB (JPG, PNG, PDF)</small>
          </div>
        </div>
      </div>

      {fileList.length > 0 && (
        <div className="uploaded-files-section">
          <div className="files-header" onClick={() => setShowDropdown(!showDropdown)}>
            <span className="files-count">
              {fileList.length} File{fileList.length > 1 ? 's' : ''} Uploaded
            </span>
            {showDropdown ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          {showDropdown && (
            <div className="files-list">
              {fileList.map((file, index) => (
                <div key={file.name || index} className="file-item">
                  <div className="file-info">
                    <div className="file-icon">
                      {isPdf(file.name) ? <FaFilePdf /> : <FaImage />} 
                    </div>
                    <div className="file-details">
                      <span className="file-name">{file.name}</span>
                      <span className="file-size">
                        {(file.size / (1024 * 1024)).toFixed(2)} MB
                      </span>
                    </div>
                  </div>
                  <div className="file-actions">
                    <button 
                      className="action-button preview-button"
                      onClick={() => previewFile(file)}
                    >
                      <FaExpand />
                    </button>
                    <button 
                      className="action-button delete-button"
                      onClick={() => remove && remove(file, index)}
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {!showDropdown && (
            <div className="file-previews-collapsed">
              {fileList.slice(0, 3).map((file, index) => (
                <div 
                  key={file.name || index} 
                  className="file-preview-mini"
                  style={{ 
                    transform: `translateX(-${index * 15}px)`,
                    zIndex: fileList.length - index
                  }}
                  onClick={() => previewFile(file)}
                >
                  {isPdf(file.name) ? (
                    <div className="pdf-mini-preview">
                      <FaFilePdf />
                      <span>PDF</span>
                    </div>
                  ) : (
                    <img 
                      src={file.preview || file.blob || URL.createObjectURL(file)} 
                      alt={`Preview ${index + 1}`}
                      className="image-mini-preview"
                    />
                  )}
                  {index === 2 && fileList.length > 3 && (
                    <div className="more-files-overlay">
                      +{fileList.length - 3}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {showDocument && currentFile && (
        <div className="document-preview-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{currentFile.name}</h3>
              <button 
                className="close-modal"
                onClick={() => setShowDocument(false)}
              >
                ×
              </button>
            </div>
            <div className="preview-content">
              {isPdf(currentFile.name) ? (
                // Using DocumentViewer for PDF
                <DocumentViewer 
                  showDocument={showDocument}
				          fileData={currentFile.blob} 
				          onClose={() => setShowDocument(false)}
                />
              ) : (
                // For images, show directly
                <img 
                  src={currentFile.preview || currentFile.blob || URL.createObjectURL(currentFile)}
                  alt={currentFile.name}
                  className="image-preview"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentCard;